import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import { View, ErrorBoundary, styled, fromTheme, webOnlyStyles } from 'lib_ui-primitives';
import SharedFilterBoundary from '../contextProviders/SharedFilterBoundary';

const Dashboard = styled(View).attrs({ name: 'dashboard-layout' })`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    width: 100%;
    flex-flow: row wrap;
    justify-content: center;
    align-content: center;
    overflow-y: auto;
    gap: ${fromTheme('mainContainer', 'gap')};
    padding: ${fromTheme('mainContainer', 'padding')};
`;

let Tile = styled(View).attrs({ name: 'Tile' })`
    flex: 1 1
        ${({ numWidgets, theme }) => {
            // mobile gets 1 widget per line, web gets 2 or 3 columns, depending on what looks better
            const numColumns = theme.mobile ? 1 : numWidgets % 3 === 0 ? 3 : 2;
            // we go a little smaller, and it will grow as needed to fill the space
            return 100 / (numColumns + 1);
        }}%;

    height: ${({ numWidgets, size, theme }) => {
        if (theme.mobile) {
            return 'auto';
        }
        const numColumns = numWidgets % 3 === 0 ? 3 : 2;
        const numRows = Math.ceil(numWidgets / numColumns);
        const modifier = size === 'tall' ? 10 : size === 'short' ? -10 : 0;
        // it's all laid out in 2 or 3 columns, and we always show everything
        // so, the full height of the parent divided by the number of rows
        // then allow a little space for pixels
        return `${100 / numRows - 1 + modifier}%`;
    }};
    max-height: ${({ numWidgets, size, theme }) => {
        if (theme.mobile) {
            return 'none';
        }
        const numColumns = numWidgets % 3 === 0 ? 3 : 2;
        const numRows = Math.ceil(numWidgets / numColumns);
        const modifier = size === 'tall' ? 10 : size === 'short' ? -10 : 0;
        return `${100 / numRows - 1 + modifier}%`;
    }};
    overflow: hidden;
`;
Tile = webOnlyStyles(Tile)`
   
`;

function DashboardLayout(props) {
    const { id, title: name = 'dashboard', children, ...otherProps } = props || {};

    // prettier-ignore
    return rc(Dashboard, { name, id, ...otherProps },
        children.map((child, i) =>
            rc(Tile, { key: `widget${i}`, numWidgets: children.length, size: child.props?.hNode?.chartHeight || 'medium' },
                rc(SharedFilterBoundary, {boundaryName: child.props?.hNode?.title}, null,
                    rc(ErrorBoundary, null,
                        child
                    )
                )
            )
        )
    );
}

DashboardLayout.propTypes = {
    children: PropTypes.array,
    hNode: PropTypes.object.isRequired
};

export default DashboardLayout;
